import { render } from "./refundPolicy.vue?vue&type=template&id=1b802a22"
import script from "./refundPolicy.vue?vue&type=script&lang=js"
export * from "./refundPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__